// @flow

export { EfectyMapLink } from './efecty-map-link';
